import { FC } from 'react';

import classNames from 'classnames';

import { ITextProps } from './text.interface';
import styles from './text.module.scss';

const Text: FC<ITextProps> = props => {
  const {
    children,
    variant = 'body',
    tone = 'default',
    color = '',
    align = 'left',
    inline = false,
    className = '',
    ...restProps
  } = props;

  const textClassNames = classNames(styles.text, className, {
    [styles[variant]]: variant,
    [styles[tone]]: tone !== 'default',
    [styles[`${align}`]]: align,
    [styles.inline]: inline,
  });

  const stylesObj = {
    color,
  };

  return (
    <p className={textClassNames} style={stylesObj} {...restProps}>
      {children}
    </p>
  );
};

export { Text };
